import { render, staticRenderFns } from "./retur-set-price-header.vue?vue&type=template&id=d88a2fe0&"
import script from "./retur-set-price-header.vue?vue&type=script&lang=js&"
export * from "./retur-set-price-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports